import React from "react";

function Stack() {
  return <div></div>;
}

export default Stack;
